module.exports = __webpack_public_path__ + "teqbahn-assets/media/3.2e0d4d05.jpg";